import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { weddingReducer } from "./weddingReducer";
import { noteReducer } from "./noteReducer";
import { shopReducer } from "./shopReducer";

export default combineReducers({
	auth: authReducer,
	wedding: weddingReducer,
	notes: noteReducer,
	shop: shopReducer,
});
